export const cpfMask = (value) => {
    if (!value) return value;
    const onlyNumbers = value.replace(/\D+/g, '');    
    return onlyNumbers
        .replace(/^(\d{3})(\d)/, '$1.$2') 
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3') 
        .replace(/\.(\d{3})(\d)/, '.$1-$2') 
        .slice(0, 14); 
};